import React, { useContext, useState, useReducer, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "axios"

import AuthContext from "../../../context/auth-context";
import RulesContext from "../../../context/rules-context";

import { dataFetchReducer } from "../../Utils/requestUtils";
import { listSorter } from "../utils"

import NewRulePieceDialog from "./Dialogs/NewRulePieceDialog";
import RulePieceTreeEngine from "./RulePieceTreeEngine";

function RulePieceTree(props) {

    const { events } = props

    let history = useHistory();
    let user_data = useContext(AuthContext).user_data;
    if (!user_data.roles.includes("rule_piece_viewer")) {
        history.push("");
    }

    let { rule_piece_key } = useParams();

    const [rulePieceDefinition, setRulePieceDefinition] = useState({
        rule_piece_key: rule_piece_key,
        user_variables: []
    });

    const [rulePieceErrorCode, setRulePieceErrorCode] = useState(null)

    const [rulePiece, dispatchRulePiece] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const [processorsVariables, dispatchProcessorsVariables] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    );

    const [company, dispatchCompany] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const [lists, dispatchLists] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const [selectedEnvironment, dispatchEnvironment] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false
    })

    const canUseMultiEnvironment = user_data.roles.includes("use_sa_rule_engine")
    
    const getEnvByRulePieceKey = (rule_piece_key) => {
        
        dispatchEnvironment({ type: "data_fetch_init" });
        axios.get("/dash/rule_engine/rule_piece/" + rule_piece_key + "/environment")
        .then((response) => {
            dispatchEnvironment({
                type: "data_fetch_success",
                payload: response.data.environment
            });
        })
        .catch((error) => {
            if ((error.response || {}).status === 403)
            dispatchEnvironment({ type: "data_fetch_failure_403" });
            else if ((error.response || {}).status === 404)
            dispatchEnvironment({ type: "data_fetch_failure_404" });
            else dispatchEnvironment({ type: "data_fetch_failure" });
        });
    };

    useEffect(() => {
        if (canUseMultiEnvironment && rule_piece_key.length === 36 /*UUID*/) {
            getEnvByRulePieceKey(rule_piece_key)
        } else {
            dispatchEnvironment({
                type: "data_fetch_success",
                payload: 'production'
            });
        }
      }, [canUseMultiEnvironment, rule_piece_key])

    useEffect(() => {
        if (selectedEnvironment.fetchedData) {
            let payload = {
                page_number: 0,
                page_rows: 1000,
                region: rulePiece.region ?? (selectedEnvironment.fetchedData === 'production_sa') ? 'sa_east_1' : 'us_east_1',
                rule_piece_context: true
            };
            dispatchLists({ type: "data_fetch_init" });
        
            const timer = setTimeout(() => {
                axios
                .get("/dash/lists/lists", { params: payload })
                .then((response) => {
                    dispatchLists({
                    type: "data_fetch_success",
                    payload: response.data,
                    });
                })
                .catch((error) => {
                    if ((error.response || {}).status === 403)
                    dispatchLists({ type: "data_fetch_failure_403" });
                    else if ((error.response || {}).status === 404)
                    dispatchLists({ type: "data_fetch_failure_404" });
                    else dispatchLists({ type: "data_fetch_failure" });
                });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rule_piece_key, rulePiece.region, canUseMultiEnvironment, selectedEnvironment]);

    const handleRulePiece = (rulePiecePayload, requestType, environment) => {
        let params = { environment: "production"}
        if (environment) {
            params.environment = environment;
        }

        dispatchRulePiece({ type: "data_fetch_init" });
        if(requestType === 'creation') {
            setTimeout(function () {
                let url = '/dash/rule_engine/rule_piece'
                axios.post(url, rulePiecePayload, { params: params }).then(response => {
                    dispatchRulePiece({
                        type: "data_fetch_success",
                        payload: response.data
                    })
    
                    if (response.data.rule_piece_key) {
                        setRulePieceDefinition((prev) => ({ ...prev, rule_piece_key: response.data.rule_piece_key, environment: response.data.environment }))
                        history.push('/rule-piece/' + response.data.rule_piece_key)
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) {
                        dispatchRulePiece({ type: "data_fetch_failure_403" })
                        setRulePieceErrorCode(403)
                    }
                    else {
                        dispatchRulePiece({ type: "data_fetch_failure" })
                        setRulePieceErrorCode((error.response || {}).status)
                    }
                });
            }, 1000);
        } else if (requestType === 'edition') {
            setTimeout(function () {
                let url = '/dash/rule_engine/rule_piece/' + rule_piece_key
                axios.put(url, rulePiecePayload, { params: params }).then(response => {
                    dispatchRulePiece({
                        type: "data_fetch_success",
                        payload: response.data
                    })
    
                    if (response.data.rule_piece_key) {
                        setRulePieceDefinition((prev) => ({ ...prev, rule_piece_key: response.data.rule_piece_key, environment: response.data.environment }))
                        history.push('/rule-piece/' + response.data.rule_piece_key)
                    }
                    return true
                }).catch(error => {
                    if ((error.response || {}).status === 403) {
                        dispatchRulePiece({ type: "data_fetch_failure_403" })
                        setRulePieceErrorCode(403)
                    }
                    else {
                        dispatchRulePiece({ type: "data_fetch_failure" })
                        setRulePieceErrorCode((error.response || {}).status)
                    }
                });
            }, 1000);
        }
    }

    useEffect(() => {
        dispatchCompany({ type: "data_fetch_init" });
        if (!user_data.business_group_key) {
            const timer = setTimeout(() => {
                axios
                    .get("/dash/rule_engine/company")
                    .then((response) => {
                        dispatchCompany({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchCompany({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchCompany({ type: "data_fetch_failure_404" });
                        else dispatchCompany({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        } else {
            const timer = setTimeout(() => {
                axios
                    .get("/dash/rule_engine/companies")
                    .then((response) => {
                        dispatchCompany({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchCompany({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchCompany({ type: "data_fetch_failure_404" });
                        else dispatchCompany({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [user_data.business_group_key]);

    const location = useLocation();
    useEffect(() => {

        if (!selectedEnvironment.fetchedData) return;
        let params = { environment: "production"}
        if (selectedEnvironment.fetchedData)
            params.environment = selectedEnvironment.fetchedData

        if (rulePieceDefinition.environment)
            params.environment = rulePieceDefinition.environment

        if (rulePieceDefinition.rule_piece_key !== 'new_rule_piece' && rule_piece_key !== 'new_rule_piece') {
            dispatchRulePiece({ type: "data_fetch_init" });
            const timer = setTimeout(() => {
                axios
                    .get(`/dash/rule_engine/rule_piece/${rulePieceDefinition.rule_piece_key}`, { params: params })
                    .then((response) => {
                        dispatchRulePiece({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchRulePiece({ type: "data_fetch_failure_403" });
                        else dispatchRulePiece({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rulePieceDefinition.rule_piece_key, rulePieceDefinition.environment, rule_piece_key, location.pathname, selectedEnvironment.fetchedData])

    useEffect(() => {
        if (!selectedEnvironment.fetchedData) return;
        let params = { environment: "production"}
        if (selectedEnvironment.fetchedData) {
            params.environment = selectedEnvironment.fetchedData;
        }

        if (rulePieceDefinition.rule_piece_key !== 'new_rule_piece') {
            dispatchProcessorsVariables({ type: "data_fetch_init" });
            const timer = setTimeout(() => {
                axios
                    .get(`/dash/rule_engine/rule_piece/${rulePieceDefinition.rule_piece_key}/processors_variables`, { params: params })
                    .then((response) => {
                        dispatchProcessorsVariables({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchProcessorsVariables({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchProcessorsVariables({ type: "data_fetch_failure_404" });
                        else dispatchProcessorsVariables({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rulePieceDefinition.rule_piece_key, selectedEnvironment]);

    if (rulePieceDefinition.rule_piece_key === 'new_rule_piece' && company.fetchedData) {
        return (
            <NewRulePieceDialog
                setRulePieceDefinition={setRulePieceDefinition}
                companies={company.fetchedData}
                rule_piece_key={rule_piece_key}
                open={true}
                handleRulePiece={handleRulePiece}
                rulePieceErrorCode={rulePieceErrorCode}
                setRulePieceErrorCode={setRulePieceErrorCode}
            />
        )
    } else if (
        rulePiece.fetchedData &&
        processorsVariables.fetchedData &&
        lists.fetchedData &&
        selectedEnvironment.fetchedData &&
        !events
    ) {
        return (
            <RulesContext.Provider
                value={{
                    fields_mapper_list: listSorter(rulePiece.fetchedData.field_mapping, "description") || [],
                    processors_variables: listSorter(processorsVariables.fetchedData, "description") || [],
                    boxes: rulePiece.fetchedData.boxes || [],
                    lists: listSorter(lists.fetchedData.data, "name") || [],
                    signals_list: [],
                    scripts_list: []
                }}
            >
                <RulePieceTreeEngine
                    rulePieceDefinition={rulePiece.fetchedData}
                />
            </RulesContext.Provider>
        )
    } else if (events && selectedEnvironment.fetchedData) {
        return (
            <NewRulePieceDialog
                setRulePieceDefinition={setRulePieceDefinition}
                companies={company.fetchedData}
                rule_piece_key={rule_piece_key}
                open={true}
                handleRulePiece={handleRulePiece}
                events={events}
                rulePieceErrorCode={rulePieceErrorCode}
                setRulePieceErrorCode={setRulePieceErrorCode}
                selectedEnvironment={selectedEnvironment.fetchedData}
            />
        )
    }

    return null
}

export default RulePieceTree

